import type { ClientMessage, RoomSnapshot, ServerMessage } from './Protocol';
import type { PlayerInput } from '../multiplayer/PlayerInput';
const SESSION_KEY='blast-arena-online-session';
export class OnlineClient {
 room:RoomSnapshot|null=null; id=''; connected=false; error='';
 onChange:()=>void=()=>{};
 private socket:WebSocket|null=null; private stopped=false; private retry:ReturnType<typeof setTimeout>|null=null;
 private resuming=false;
 private session:{code:string;token:string}|null=null; private seq=0; private queued:ClientMessage|null=null;
 constructor(){try{const raw=sessionStorage.getItem(SESSION_KEY);if(raw){const value=JSON.parse(raw);if(typeof value.code==='string'&&typeof value.token==='string')this.session=value;}}catch{}}
 connect():void {
  if(this.stopped||this.socket&&(this.socket.readyState===WebSocket.OPEN||this.socket.readyState===WebSocket.CONNECTING))return;
  const socket=new WebSocket(`${location.protocol==='https:'?'wss:':'ws:'}//${location.host}${import.meta.env.BASE_URL}online`);this.socket=socket;
  socket.onopen=()=>{if(this.socket!==socket)return;this.connected=true;this.error='';
   if(this.session){this.resuming=true;this.send({type:'resume',...this.session});}else if(this.queued){this.send(this.queued);this.queued=null;}this.onChange();};
  socket.onmessage=event=>{if(this.socket!==socket)return;let message:ServerMessage;try{message=JSON.parse(event.data);}catch{return;}
   if(message.type==='welcome'){this.resuming=false;this.id=message.id;this.room=message.room;this.session={code:message.room.code,token:message.token};this.queued=null;try{sessionStorage.setItem(SESSION_KEY,JSON.stringify(this.session));}catch{}this.error='';}
   else if(message.type==='snapshot')this.room=message.room;
   else if(message.type==='error'){this.error=message.message;if(this.resuming){this.resuming=false;this.room=null;this.id='';this.session=null;try{sessionStorage.removeItem(SESSION_KEY);}catch{}}}
   this.onChange();
  };
  socket.onerror=()=>{this.error='Nu mă pot conecta la serverul online.';this.onChange();};
  socket.onclose=()=>{if(this.socket!==socket)return;this.connected=false;this.socket=null;this.onChange();if(!this.stopped)this.retry=setTimeout(()=>this.connect(),1200);};
 }
 send(message:ClientMessage):void {
  if(this.socket?.readyState===WebSocket.OPEN)this.socket.send(JSON.stringify(message));
  else if(message.type==='create'||message.type==='join'){this.queued=message;this.connect();}
 }
 input(input:PlayerInput):void{if(this.connected&&this.room?.phase==='playing')this.send({type:'input',seq:this.seq++,input});}
 close():void {
  this.stopped=true;if(this.retry)clearTimeout(this.retry);this.send({type:'leave'});this.socket?.close();this.socket=null;this.connected=false;
  try{sessionStorage.removeItem(SESSION_KEY);}catch{}this.room=null;this.session=null;
 }
}
